module.exports = __webpack_public_path__ + "img/04.0a377f49.png";